import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ServiceDetailConst } from '../../../constants';
import { ServiceDetailSec } from '../../components';
import styles from "./serviceDetail.module.css";
import { useDispatch, useSelector } from "react-redux";
import { fetchWhatWeDoDetailsData } from '../../slice/whatWeDoSlice';
import { fetchPartnerData } from '../../slice/partnerSlice';
import { fetchConfigData } from '../../slice/configSlice';

const ServiceDetail = () => {
    const { serviceId } = useParams();
    //const serviceD = ServiceDetailConst.find(service => service.title.toLowerCase() === serviceId);
    // if (!serviceD) return <div>Service not found</div>;
    const dispatch = useDispatch();
    const { data: serviceData, loading, error } = useSelector((state) => state.whatWeDo);
    const { data: partnerData } = useSelector((state) => state.partner);
    const { data: configData } = useSelector((state) => state.config);

    /* const {
        whatWeDo: { data: serviceData, loading, error },
        partner: { partner: partnerData }
    } = useSelector((state) => state); */


    useEffect(() => {
        console.log("test");
        dispatch(fetchWhatWeDoDetailsData(serviceId));
        dispatch(fetchPartnerData());
        dispatch(fetchConfigData());
    }, [dispatch, serviceId]);

    useEffect(() => {
        console.log("Partner Data  : ", partnerData);
        console.log("Config Data  : ", configData);
    }, [partnerData, configData]);

    return (
        <section className={styles.ServiceDetail}>
            {
                serviceData && partnerData && configData && <ServiceDetailSec serviceD={serviceData} partnerData={partnerData} configData={configData} />
            }

        </section>
    );
};

export default ServiceDetail;
